<script setup lang="ts">
import type { components } from '~/types/napis'

const props = defineProps({
  tag: {
    type: Object as PropType<
      | components['schemas']['DiscussionTagOptionSchema']
      | components['schemas']['TagResponseSchema']
    >,
    required: true
  },
  enableLink: { type: Boolean, default: true },
  showCross: { type: Boolean, default: false }
})

const tagClass = computed(() => {
  // delete later once tag object is consistent with type
  const category = props.tag.category
  let categoryName = ''
  if (typeof category === 'object') categoryName = category?.category_name || ''
  else categoryName = category

  let cls = 'tag-pill '

  // colour
  if (categoryName === 'GENERAL') cls += ' tag-pill-blue '
  else if (categoryName === 'SKILL') cls += ' tag-pill-green '
  else if (categoryName === 'CAREER') cls += ' tag-pill-red '
  else cls += ' tag-pill-orange '

  // hover
  if (props.enableLink) {
    cls += ' clickable '
    if (categoryName === 'GENERAL') cls += ' tag-pill-blue-hover '
    else if (categoryName === 'SKILL') cls += ' tag-pill-green-hover '
    else if (categoryName === 'CAREER') cls += ' tag-pill-red-hover '
    else cls += ' tag-pill-orange-hover '
  }

  return cls
})

const isClass = computed(() => {
  // delete later once tag object is consistent with type
  const category = props.tag.category
  let categoryName = ''
  if (typeof category === 'object') categoryName = category?.category_name || ''
  else categoryName = category
  return categoryName === 'CLASSROOM'
})

const link = computed(() => {
  if (props.enableLink)
    return `/forum/${isClass.value ? 'class-forum' : 'tag'}/${props.tag.slug_name}`
  return ''
})
</script>

<template>
  <NuxtLink :class="tagClass" :to="link">
    <CommonIconLock v-if="isClass" />
    <span>{{ isClass ? tag.name : `# ${tag.name}` }}</span>
    <CommonIconClose v-if="showCross" class="cross" />
  </NuxtLink>
</template>

<style scoped lang="scss">
$svgSize: 10px;

.tag-pill {
  min-height: 30px;
  padding: 5px 13px;
  display: flex;
  align-items: center;
  border-radius: 7px;
  gap: 10px;
  border: 1px solid transparent;
  transition:
    color 0.3s ease-out,
    border 0.3s ease-out,
    background 0.3s ease-out;
  text-align: left;

  svg {
    $svgSize: 12px;
    height: $svgSize;
    width: $svgSize;
    fill: white;
    flex-shrink: 0;
  }

  span {
    display: block;
    font-size: 0.87rem;
    font-weight: 500;
    color: white;
  }

  .cross {
    $svgSize: 10px;
    height: $svgSize;
    width: $svgSize;
    margin-left: 10px;
  }
}

// COLORS
.tag-pill {
  &-green {
    /* background: var(--forumLightGreen); */
    background: var(--forumGreen);
    border-color: var(--forumGreen);

    /* span {
      color: var(--forumGreen);
    } */
  }

  &-blue {
    /* background: var(--forumLightBlue); */
    background: var(--forumBlue);
    border-color: var(--forumBlue);

    /* span {
      color: var(--forumBlue);
    } */
  }

  &-red {
    /* background: var(--forumLightRed); */
    background: var(--forumRed);
    border-color: var(--forumRed);

    /* span {
      color: var(--forumRed);
    } */
  }

  &-orange {
    /* background: var(--forumYellowBg); */
    background: rgb(201, 163, 9);

    /* span {
      color: var(--forumYellowText);
    }

    svg {
      fill: var(--forumYellowText);
    } */
  }
}

@media (hover: hover) {
  .clickable:hover {
    background: white;
  }

  .tag-pill {
    &-green-hover:hover span {
      color: var(--forumGreen);
    }

    &-blue-hover:hover span {
      color: var(--forumBlue);
    }

    &-red-hover:hover span {
      color: var(--forumRed);
    }

    &-orange-hover:hover {
      border-color: var(--forumYellowText);

      span {
        color: var(--forumYellowText);
      }

      svg {
        fill: var(--forumYellowText);
      }
    }
  }
}
</style>
